// DEMO ONLY. Every value on the full-page Orbit workspace, verbatim from
// the Figma design. Replace with API data and delete this module.

export interface IOrbitPageChip {
  label: string;
}

export interface IOrbitPageContextField {
  label: string;
  value: string;
}

export const ORBIT_PAGE_MOCK = {
  rail: {
    title: 'Perx Orbit',
    subtitle: 'AI analytics workspace'
  },
  welcome: {
    title: 'What would you like to explore?',
    subtitle:
      'Get instant insights from your customer, campaign and engagement data using natural language.',
    placeholder: 'Ask Orbit about customers, campaigns, performance or opportunities...',
    // Date range is the only analytical filter: 6114:4166's segment and comparison chips are gone.
    chips: [{ label: 'Period: Last 30 Days' }] as IOrbitPageChip[]
  },
  drawer: {
    title: 'Change analysis context',
    subtitle: 'Control what Orbit should use for this analysis.',
    fields: [
      { label: 'Data scope', value: 'Customer Insights + Customer 360' },
      { label: 'Date range', value: 'Last 30 days' }
    ] as IOrbitPageContextField[]
  },
  explore: {
    title: 'Explore More with Perx',
    subtitle: 'Additional High-Impact Mechanics & Enterprise Modules Available for Evaluation',
    filter: 'All'
  }
};
